<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2025-01-08 11:03:44
 * @FilePath: src/views/index/header/index.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<!--
  @Author 22030124/xieyq
  @Date 2023-12-04 09:29:48
  @Description 首页 =》头部组件
-->
<template>
  <!-- 右侧 -->
  <div :class="`${scope.clsPrefix}_right`">
    <!-- 移除了搜索框 -->
    <ul :class="`${scope.clsPrefix}_menu`">
      <!-- AI 助手入口 -->
      <!-- <el-button
        :class="`${scope.clsPrefix}_btn ai-btn`"
        circle
        @click.stop="showAiDialog = true"
      >
        <i class="el-icon-service"></i>
      </el-button> -->
      <!-- <img src="@/assets/imgs/liucheng.png" style="cursor: pointer;" @click.stop="openFullScreenDialog" alt="" width="20px" height="20px"> -->
      <!-- <img
        v-if="aiOpen"
        src="@/assets/imgs/kefu.png"
        style="cursor: pointer"
        @click.stop="showAiDialog = true"
        alt=""
        width="20px"
        height="20px"
      /> -->
      <!-- 应用 -->
      <index-header-apps ref="headerApps"></index-header-apps>
      <!-- 工作台 -->
      <li
        v-if="userInfo.department != 'OPC' && !isSmartRoute"
        :class="[
          `${scope.clsPrefix}_menu_item`,
          { 'is-active': activeMenu === '/' },
        ]"
        :id="`${scope.clsPrefix}_menu_item`"
        style="
          border: 1px solid transparent;
          background-image: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
          color: white;
        "
        @click="
          currentWorkbench.name ? clickHome() : handleCurrentWorkbench('create')
        "
        @mouseleave="isWorkDropdownVisible = false"
      >
        <!-- <img
          src="@/assets/imgs/icon/workbench.png"
          width="16px"
          height="16px"
          alt=""
        /> -->
        <span slot="title">{{ currentWorkbench.name || '我的工作台' }}</span>
        <span
          v-if="!currentWorkbench.name || currentWorkbench.name == '我的工作台'"
          style="margin-left: 5px"
          class="el-icon-edit-outline"
          @click.stop="
            currentWorkbench.name == '我的工作台'
              ? designWorkbench(currentWorkbench.id)
              : ''
          "
        ></span>
        <div
          class="dropdown"
          v-if="workbenchList.length > 1"
          @click.stop="handleWorkDropdown"
        >
          <i
            :class="`${scope.clsPrefix}_menu_item_dropdown_link`"
            class="el-icon-caret-bottom"
          ></i>
        </div>
        <transition name="work-dropdown">
          <div
            :class="[`${scope.clsPrefix}_dropdown_menu`]"
            v-if="isWorkDropdownVisible"
            @click.stop
          >
            <div
              :class="[`${scope.clsPrefix}_dropdown_menu_container`]"
              id="workDropdownMenu"
              style="left: auto"
              ref="workPopover"
            >
              <div
                :class="[
                  { active: item.id === currentWorkbench.id },
                  `${scope.clsPrefix}_dropdown_menu__item`,
                ]"
                v-for="item in workbenchList"
                :key="item.id"
                @click="handleCurrentWorkbench(item.id)"
              >
                {{ item.name }}
                <span
                  v-if="item.name == '我的工作台'"
                  style="margin-left: 5px"
                  class="el-icon-edit-outline"
                  @click.stop="designWorkbench(item.id)"
                ></span>
              </div>
              <div
                :class="`${scope.clsPrefix}_dropdown_menu__item`"
                v-if="!workbenchList.some((item) => item.name === '我的工作台')"
                @click="handleCurrentWorkbench('create')"
              >
                我的工作台
                <span
                  style="margin-left: 5px"
                  class="el-icon-edit-outline"
                ></span>
              </div>
            </div>
          </div>
        </transition>
      </li>
      <!-- 租户切换（从头像下拉中移至导航栏直接展示） -->
      <li
        v-show="sysConfig.showTenant === true && userInfo.department != 'OPC'"
        :class="[
          `${scope.clsPrefix}_menu_item`,
          `${scope.clsPrefix}_tenant-switch`,
          { 'is-active': showTenantList },
        ]"
        @click.stop="showTenantList = !showTenantList"
        @mouseleave="showTenantList = false"
      >
        <span class="tenant-btn-text">{{ currentTenant && currentTenant.name }}</span>
        <i class="el-icon-caret-bottom" style="font-size: 12px; margin-left: 2px"></i>
        <transition name="work-dropdown">
          <div
            v-show="showTenantList && tenantList && tenantList.length > 0"
            :class="[`${scope.clsPrefix}_dropdown_menu`]"
            class="tenant-dropdown-menu"
            @click.stop
          >
            <div
              :class="[`${scope.clsPrefix}_dropdown_menu_container`]"
              id="tenantDropdownMenu"
            >
              <div class="tenant-dropdown-body">
                <div
                  :class="[
                    `${scope.clsPrefix}_dropdown_menu__item`,
                    {
                      active:
                        item.id === (currentTenant && currentTenant.id),
                    },
                  ]"
                  v-for="item in tenantList"
                  :key="item.id"
                  @click="changeTenant(item.id)"
                >
                  <div class="tenant-item-text">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </li>
      <!-- 工作台下拉菜单 -->
      <!-- 运营管理中心 -->
      <!-- <li
        v-if="flag"
        :class="[
          `${scope.clsPrefix}_menu_item`,
          { 'is-active': activeMenu.includes('/maxkey-mgt') },
        ]"
        @click="$router.push('/maxkey-mgt')"
      >
        <img
          src="@/assets/imgs/icon/manage.png"
          width="16px"
          height="16px"
          alt=""
        />
        <span slot="title">{{maxkeyMgtName}}</span>
      </li> -->
    </ul>
    <!-- 业务系统集成配置入口 -->
    <!-- <button
      v-if="showSystemIntegrationEntry"
      type="button"
      class="system-integration-link"
      :class="{ active: isSystemIntegrationPage }"
      @click="goToSystemIntegration"
    >
      业务系统集成配置
    </button> -->
    <!-- 待办 -->
    <!-- <el-button :class="`${scope.clsPrefix}_btn`" icon="iconfont icon-todo" circle></el-button> -->
    <!-- <el-badge :value="5" :class="`${scope.clsPrefix}_badge`"> -->
    <!-- 通知 -->
    <!-- <el-button :class="`${scope.clsPrefix}_btn`" icon="iconfont icon-notice" circle></el-button> -->
    <!-- </el-badge> -->
    <!-- 收藏 -->
    <!-- <el-button :class="`${scope.clsPrefix}_btn`" icon="iconfont icon-collect" circle></el-button> -->
    <!-- 聊天 -->
    <!-- <el-button :class="`${scope.clsPrefix}_btn`" icon="iconfont icon-chat" circle></el-button> -->
    <!-- 登录信息 -->
    <div
      :class="[`${scope.clsPrefix}_dropdown`]"
      @mouseleave="isDropdownVisible = false"
    >
      <!-- <div class="header-separator"></div> -->
      <!-- 关于页面入口 -->
      <el-button
        v-if="userInfo.department != 'OPC'"
        :class="`${scope.clsPrefix}_btn about-btn`"
        circle
        @click.stop="goToAbout"
        :data-title="$t('header.aboutSystem')"
      >
        <i class="el-icon-info"></i>
      </el-button>
      <!-- 添加分隔线 -->
      <!-- <div class="header-separator"></div> -->
      <el-tooltip :content="userName" placement="bottom">
        <span :class="`${scope.clsPrefix}_name`">{{ userName }}</span>
      </el-tooltip>
      <img
        :src="userAvatar || require('@/assets/imgs/user_avatar.png')"
        :class="`${scope.clsPrefix}_avatar`"
        @click="handleUserDropdown"
      />
      <transition name="dropdown">
        <div
          :class="[`${scope.clsPrefix}_dropdown_menu`]"
          v-if="isDropdownVisible"
        >
          <div
            :class="[`${scope.clsPrefix}_dropdown_menu_container`]"
            id="userDropdownMenu"
            ref="logoutPopover"
          >
            <div
              :class="[`${scope.clsPrefix}_dropdown_menu__item`]"
              command="profile"
              @click="goToProfile"
              style="width: 140px"
            >
              {{ $t('header.personalCenter') }}
            </div>
            <div
              :class="[`${scope.clsPrefix}_dropdown_menu__item`]"
              style="width: 140px"
              @click.stop
              @mouseenter="showLanguageList = true"
              @mouseleave="showLanguageList = false"
            >
              <div class="tenant_item">
                <div style="position: relative; width: 100%">
                  <div class="tenant_item-name ellipsis-text">
                    {{ currentLanguageName }}
                  </div>
                  <i class="tenant_item-arrow-down el-icon-arrow-down"></i>
                  <transition name="dropdown">
                    <div
                      v-show="showLanguageList"
                      id="language_list"
                      :class="[`${scope.clsPrefix}_dropdown_menu`]"
                    >
                      <div
                        class="language_list-container"
                        :class="[`${scope.clsPrefix}_dropdown_menu_container`]"
                      >
                        <div
                          class="language_item-item"
                          :class="[
                            `${scope.clsPrefix}_dropdown_menu__item`,
                            { active: currentLocale === lang.value },
                          ]"
                          v-for="lang in languageList"
                          :key="lang.value"
                          @click="selectLanguage(lang.value)"
                        >
                          <div class="language_item-name ellipsis-text">
                            {{ $t(lang.name) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <div
              :class="[`${scope.clsPrefix}_dropdown_menu__item`]"
              command="logout"
              @click="handleLogout"
              style="width: 140px"
            >
              {{ $t('header.logout') }}
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- AI 助手对话框 -->
    <el-dialog
      :visible.sync="showAiDialog"
      width="820px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      :modal="false"
      @closed="onAiDialogClosed"
      class="ai-dialog"
    >
      <button
        class="ai-close"
        type="button"
        @click="showAiDialog = false"
        aria-label="关闭"
      >
        <i class="el-icon-close"></i>
      </button>
      <div style="height: 560px">
        <iframe
          :src="aiChatUrl"
          frameborder="0"
          allow="microphone"
          style="
            width: 100%;
            height: 100%;
            border-radius: 8px;
            background: #fff;
          "
        ></iframe>
      </div>
    </el-dialog>
    <FullScreenDialog ref="fullScreenDialogRef" />
  </div>
</template>

<script>
// 应用
import IndexHeaderApps from '@/views/index/header/apps/index.vue'
import FullScreenDialog from './dialog/flow.vue'
import { mapGetters, mapState } from 'vuex'
import { setLanguage } from '@/utils/i18n'
// 请求工作台列表
import {
  requestWorkbenches,
  switchWorkplace,
  requestQuickApps,
  requestAppGroupsByDomain
} from '@/api/app.js'
import { requestCreateWorkbench } from '@/api/work-bench.js'
// import { changeCurrentTenant } from '@/api/user.js'
// 引入配置获取函数
// import { fetchAllConfigs } from '@/api/fetchConfig.js'
// import { mapActions } from 'vuex' // 引入 mapActions 辅助函数
import microApp from '@micro-zoe/micro-app'
import { getConfigByCode } from '@/api/setting'
export default {
  // 组件名称
  name: 'IndexHeaderSider',
  components: {
    IndexHeaderApps,
    FullScreenDialog
  },
  // 提供
  provide() {
    return {
      // 容器
      con: this
    }
  },
  // 数据
  data() {
    return {
      // 移除了searchValue变量
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'index-head-sider'
      },
      // 激活的索引
      activeIndex: '1',
      // 是否显示ai对话
      aiOpen: false,
      // 是否显示app
      appShow: false,
      // 工作台列表
      workbenchList: [],
      isDropdownVisible: false,
      isWorkDropdownVisible: false,
      logoUrl: '', // 新增logoUrl
      faviconUrl: '', // 新增faviconUrl
      tabTitle: '', // 新增tabTitle
      flag: false,
      maxkeyMgtName: '运营管理后台',
      showTenantList: false,
      showLanguageList: false,
      languageList: [
        { value: 'zh-CN', name: 'language.zh_CN', code: '简体中文' },
        { value: 'zh-TW', name: 'language.zh_TW', code: '繁體中文' },
        { value: 'en', name: 'language.en', code: 'English' }
        // { value: 'ja', name: 'language.ja', code: '日本語' },
        // { value: 'th', name: 'language.th', code: 'ไทย' },
        // { value: 'es', name: 'language.es', code: 'Español' }
      ],
      // AI 助手
      showAiDialog: false,
      aiChatUrl:
        'https://devagent.cosmoplat.cn/chat/assistant/9088a5ddd09c491c821f2313941fadd0?share=true&style=copilot'
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['name', 'avatar', 'currentWorkbench', 'myWorkbenchId']),
    ...mapState('user', [
      'userInfo',
      'tenantList',
      'currentTenant',
      'sysConfig'
    ]),
    // 用户名
    userName() {
      return this.name
    },
    // 用户头像
    userAvatar() {
      return this.avatar
    },
    // 活跃的菜单
    activeMenu() {
      return this.$route.path
    },
    // 是否处于智擎路由（/smart-engine 或 /dashboard 子路由）
    isSmartRoute() {
      const path = this.$route.path
      return path.startsWith('/smart-engine') || path.includes('dashboard')
    },
    // 当前语言
    currentLocale() {
      return this.$store.getters['locale/locale'] || 'zh-CN'
    },
    // 当前语言名称
    currentLanguageName() {
      const lang = this.languageList.find((l) => l.value === this.currentLocale)
      return lang ? this.$t(lang.name) : '简体中文'
    },
    // 是否展示业务系统集成配置入口（与工作台模式胶囊同条件）
    showSystemIntegrationEntry() {
      const name = (this.currentWorkbench?.name || '').toLowerCase()
      return name.includes('ceo') || name.includes('cfo') || name.includes('cso')
    },
    isSystemIntegrationPage() {
      return this.$route.path === '/system-integration-config'
    }
  },
  // 创建完成
  mounted() {
    // 初始化方法
    this.init()
  },
  // 方法
  methods: {
    openFullScreenDialog() {
      this.$refs.fullScreenDialogRef.openDialog()
    },
    // 跳转到业务系统集成配置
    goToSystemIntegration() {
      if (this.$route.path !== '/system-integration-config') {
        this.$router.push('/system-integration-config')
      }
    },
    // 跳转到关于页面
    goToAbout() {
      this.$router.push('/about')
    },
    // 跳转到个人中心页面
    goToProfile() {
      this.$router.push('/profile/config')
      this.isDropdownVisible = false
    },
    changeTenant(id) {
      // this.$confirm({
      //   title: '提示',
      //   content: '切换租户将刷新当前数据',
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      this.$confirm(this.$t('header.switchTenantTip'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'), // 确认按钮文字
        cancelButtonText: this.$t('common.cancel'), // 取消按钮文字
        type: 'warning' // 提示类型（success/info/warning/error，影响图标）
      })
        .then(() => {
          this.$store.dispatch('user/changeTenant', id)
        })
        .catch(() => {
          // 取消切换租户
          console.log(22222222222222222222222222222222)
        })
    },
    selectLanguage(locale) {
      if (locale === this.currentLocale) {
        this.showLanguageList = false
        return
      }
      setLanguage(locale)
      this.$store.dispatch('locale/setLocale', locale)
      this.showLanguageList = false
      this.isDropdownVisible = false
      window.location.reload()
    },
    handleLogout() {
      this.$store.dispatch('user/logout')
    },
    createPersonalWorkbench() {
      const data = {
        type: 'PERSONAL',
        name: '我的工作台',
        status: 'ENABLE',
        weight: '1000'
      }
      // 请求新增接口
      requestCreateWorkbench(data)
        .then((res) => {
          const workBenchId = res.data.id
          this.getData()
          this.designWorkbench(workBenchId)
        })
        .catch(() => {
          this.loading = false
        })
    },
    designWorkbench(id) {
      this.$store.dispatch('app/updateDesignWorkbench', id)
      this.$router.replace({
        path: '/',
        query: { mode: 'design', id: id }
      })
    },
    handleCurrentWorkbench(command) {
      if (command == 'create') {
        this.createPersonalWorkbench()
        return
      }
      if (this.currentWorkbench?.id === command) {
        this.$router.replace('/')
        return
      }
      this.workbenchList.some((item) => {
        if (item.id === command) {
          switchWorkplace(item.id).then((res) => {
            console.log(res)
          })
          this.$store.dispatch('app/updateCurrentWorkbench', item)
          this.$router.replace('/')
          return true
        }
        return false
      })
    },

    /**
     * 初始化方法
     * @returns {void}
     */
    async init() {
      // 获取数据
      this.getData()
      // 先获取租户列表（currentTenant 会被 getAppData 依赖）
      await this.$store.dispatch('user/getTenantList')
      this.getAppData()
      this.getAiOpen()
    },
    getAiOpen() {
      getConfigByCode({
        code: 'aiRobotDisplay'
      }).then((res) => {
        if (res.data?.configValue === 'true') {
          this.aiOpen = true
        } else {
          this.aiOpen = false
        }
      })
    },

    /**
     * 获取数据
     */
    getData() {
      // 开始加载
      this.loading = true
      requestWorkbenches()
        .then(({ data }) => {
          this.workbenchList = data
          const workPlaceId = this.userInfo?.workPlaceId
          const currentWorkbench = this.workbenchList.find(
            (item) => item.id === workPlaceId
          )

          if (currentWorkbench) {
            // 如果找到匹配的工作台，设置为当前工作台
            this.$store.dispatch('app/updateCurrentWorkbench', currentWorkbench)
          } else if (this.workbenchList.length > 0) {
            // 否则，将列表的第一项设为当前工作台
            this.$store.dispatch(
              'app/updateCurrentWorkbench',
              this.workbenchList[0]
            )
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // getQuickApps() {
    //   requestQuickApps(10)
    //     .then(({ data }) => {
    //       this.$store.commit('app/SET_NORMAL_APPLIST', data)
    //     })
    //     .catch(() => {})
    // },

    /**
     * 获取app数据
     * @returns {void}
     */
    async getAppData() {
      // 请求权限菜单
      const menuList = await this.$store.dispatch('user/getUserMenus')
      // 组装权限路由
      await this.$store.dispatch('permission/generateRoutes', menuList)
      try {
        // 并行请求应用分类列表和常用应用列表
        const params = {}
        if (this.currentTenant?.industryLabelId) {
          params.industryLabelId = this.currentTenant.industryLabelId
        }
        const [appGroupsResponse, quickAppsResponse] = await Promise.all([
          requestAppGroupsByDomain(params),
          requestQuickApps(10)
        ])

        const appGroupsData = appGroupsResponse.data
        const quickAppsData = quickAppsResponse.data

        // 保持原始的三层结构(领域->分类->应用)，不再扁平化
        const domainData = this.processDomainData(appGroupsData)

        console.log('处理后的领域数据:', domainData)

        // 更新组件数据和 sessionStorage
        sessionStorage.setItem('domainData', JSON.stringify(domainData))
        this.$store.commit('app/SET_DOAMIN_DATA', domainData)
        // 为了兼容性，同时生成扁平化数据用于搜索等功能
        const flattenedData = this.flattenDomainData(appGroupsData)
        const appList = []
        const dataList = [
          {
            appList: []
          }
        ]
        flattenedData.forEach((element) => {
          if (element.appList && element.appList.length > 0) {
            appList.push(
              ...element.appList.map((app) => ({
                apiUrl: app.apiUrl,
                url: app.url,
                context: app.context,
                owner: app.ownerUserCode,
                isOwner:
                  app.ownerUserCode ===
                  this.$store.state.user.userInfo.userCode
              }))
            )
            dataList[0].appList.push(...element.appList)
          }
        })
        sessionStorage.setItem('appList', JSON.stringify(appList))
        this.$store.commit('app/SET_DATA_LIST', dataList)
        sessionStorage.setItem('dataList', JSON.stringify(dataList))

        // 设置常用应用列表
        if (quickAppsData) {
          this.$store.commit('app/SET_NORMAL_APPLIST', quickAppsData)
        }
      } catch (error) {
        console.error('获取数据时出错:', error)
        // 可以在这里添加更多的错误处理逻辑，例如显示错误提示给用户
      }
    },

    /**
     * 处理领域数据，保持三层结构
     * @param {Array} domainData 领域数据
     * @returns {Array} 处理后的领域数据
     */
    processDomainData(domainData) {
      if (!domainData || !Array.isArray(domainData)) {
        return []
      }

      return domainData.map((domain) => ({
        // 领域信息
        domainId: domain.domainId || domain.id,
        domainName: domain.domainName || domain.name,
        domainDesc: domain.domainDesc || domain.description,
        weight: domain.weight || 0,

        // 分类列表
        categories: (
          domain.categories ||
          domain.appCategories ||
          domain.categoryList ||
          []
        ).map((category) => ({
          appCategoryId:
            category.appCategoryId || category.categoryId || category.id,
          appCategoryName:
            category.appCategoryName || category.categoryName || category.name,
          appCategoryDesc:
            category.appCategoryDesc ||
            category.categoryDesc ||
            category.description ||
            category.desc,
          weight: category.weight || 0,
          appList:
            category.appList || category.apps || category.applications || [],
          ...category
        })),

        // 保留原始数据
        ...domain
      }))
    },

    /**
     * 将新的三层结构(领域->分类->应用)扁平化为两层结构(分类->应用)
     * @param {Array} domainData 领域数据
     * @returns {Array} 扁平化后的分类数据
     */
    flattenDomainData(domainData) {
      if (!domainData || !Array.isArray(domainData)) {
        return []
      }

      const flattenedCategories = []

      domainData.forEach((domain) => {
        // 兼容多种可能的字段名
        const categories =
          domain.categories || domain.appCategories || domain.categoryList || []

        if (categories && Array.isArray(categories)) {
          categories.forEach((category) => {
            // 保持原有的分类数据结构，添加领域信息
            flattenedCategories.push({
              // 领域信息
              domainId: domain.domainId || domain.id,
              domainName: domain.domainName || domain.name,

              // 分类信息 - 兼容多种字段名
              appCategoryId:
                category.appCategoryId || category.categoryId || category.id,
              appCategoryName:
                category.appCategoryName ||
                category.categoryName ||
                category.name,
              appCategoryDesc:
                category.appCategoryDesc ||
                category.categoryDesc ||
                category.description ||
                category.desc,
              weight: category.weight || 0,

              // 应用列表 - 兼容多种字段名
              appList:
                category.appList ||
                category.apps ||
                category.applications ||
                [],

              // 保留原始数据
              ...category
            })
          })
        }
      })

      return flattenedCategories
    },

    /**
     * 处理下拉框
     * @param {String} command 指令
     * @returns {void}
     */
    handleUserDropdown(command) {
      this.isDropdownVisible = !this.isDropdownVisible
    },

    /**
     * 处理工作台下拉框
     * @param {String} command 指令
     * @returns {void}
     */
    clearSmartWorkspaceQuery() {
      const query = { ...this.$route.query }
      delete query.agentId
      delete query.sessionKey
      const replacePromise = this.$router.replace({
        path: this.$route.path,
        query
      })
      if (replacePromise && replacePromise.catch) {
        replacePromise.catch(() => {})
      }
    },
    switchWorkspace(mode) {
      if (mode === 'smart') {
        this.$router.push('/smart-engine')
      } else {
        this.$router.push('/')
      }
    },
    handleWorkDropdown(command) {
      this.isWorkDropdownVisible = !this.isWorkDropdownVisible
    },
    onAiDialogClosed() {
      // 关闭时重置，避免残留状态
      this.showAiDialog = false
      // 可根据需要清理会话或恢复页面滚动
      document.body.style.overflow = ''
    },
    /**
     * 点击跳转到首页
     * @returns {void}
     */
    clickHome() {
      // this.$router.push("/");
      if (this.$route.path != '/') {
        // window.open("/", "_self");
        microApp.unmountAllApps().then(() => {
          this.$router.push('/')
        })
      } else {
        this.handleWorkDropdown()
      }
    },

    /**
     * 点击菜单信息项
     * @param {*} itemData 信息项数据
     * @returns {void}
     */
    clickMenuItem(itemData) {
      // 进入对应的子应用
      this.$router.push({
        path: `/${itemData.meta.context || ''}/`
      })
    },

    /**
     * 点击应用
     * @returns {void}
     */
    clickApp() {
      // 显示侧边栏
      this.$store.dispatch('app/updateShowAside', true)
    }
  }
}
</script>

<style lang="scss">
.tenant_list-container {
  height: 300px;
  overflow-y: auto;
  &::before {
    content: none;
    display: none;
  }
}
.language_list-container {
  // height: 300px;
  overflow-y: auto;
  &::before {
    content: none;
    display: none;
  }
}
.tenant_item-arrow-down {
  position: absolute;
  top: 50%;
  right: -13px;
  transform: translateY(-50%);
}
.tenant_item {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}
.tenant_item-name {
  width: 100%;
  // flex: 1;
  // display: inline-block;
  // position: relative;
}
.ellipsis-text {
  /* 核心：文本超出显示省略号 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
// 组件样式
$class-prefix: 'index-head-sider';

.#{$class-prefix} {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background: linear-gradient(90deg, #F4F8FD 0%, #FFFFFF 100%);
  // box-shadow: inset 0px -1px 0px 0px #DDE1EF;
  z-index: 10;

  // 活跃状态
  &.active {
    box-shadow: inset 0px -1px 0px 0px #dde1ef, 0px 4px 25px 0px #e3e6eb;
    z-index: 4;
  }

  // 主体内容
  &_body {
    display: flex;
    align-items: center;
    flex: 1;
  }

  // logo
  &_logo {
    width: 199px;
    height: 48px;
    margin-left: 21px;
    cursor: pointer;
    background: url('@/assets/logo.png') center center / contain no-repeat;
  }

  // 菜单
  &_menu {
    flex-shrink: 0;
    display: flex;
    gap: 22px;
    align-items: center;
    // margin-left: 68px;
    @media screen and (max-width: 1440px) {
      gap: 10px;
    }

    // 菜单信息项
    &_item {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      border: 1px solid transparent;
      padding: 0 12px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 32px;
      height: 32px;
      border-radius: 4px;
      cursor: pointer;
      background-color: #f7f8fc;
      position: relative;
      white-space: nowrap;

      // width: 160px;
      // 鼠标滑过
      &:hover,
      // 激活
      &.is-active {
        color: #fff;
        background: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
      }
    }

    // 语言切换器样式
    .language-switcher {
      color: #333333;
      font-size: 14px;
      font-weight: 500;

      .lang-current {
        padding: 6px 10px;
        border-radius: 4px;

        &:hover {
          background-color: rgba(74, 95, 243, 0.1);
        }
      }

      .lang-dropdown {
        background: #fff;
      }

      .dropdown-item {
        &:hover {
          background-color: #f5f7fa;
        }

        &.is-active {
          background-color: #ecf5ff;

          .item-name {
            color: #4a5ff3;
          }
        }

        .active-icon {
          color: #4a5ff3;
        }
      }

      .item-code {
        background: #f0f2f5;
      }
    }

    // 鼠标滑过和激活状态
    &:hover,
    // 激活
    &.is-active {
      // color: #fff;
      // background: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);

      // img {
      //   filter: brightness(0) invert(1);
      // }
      &_dropdown_link {
        color: #fff;
      }
    }

    // 箭头
    &_arrow {
      visibility: hidden;
      font-size: 14px;
    }

    &:hover &_arrow,
    // 激活
    &.is-active &_arrow {
      visibility: visible;
    }
  }

  &.ai-btn {
    position: relative;
    &:hover::after {
      content: attr(data-title);
      position: absolute;
      top: 40px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #333;
      color: #fff;
      padding: 5px 10px;
      border-radius: 5px;
      font-size: 12px;
      z-index: 1000;
      white-space: nowrap;
    }
  }

  // 右侧
  &_right {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-right: 16px;

    .el-button + .el-button {
      margin-left: 0;
    }

    .system-integration-link {
      height: 32px;
      padding: 0 14px;
      border-radius: 4px;
      border: 1px solid #c9d4ea;
      background: #fff;
      color: #4a5ff3;
      font-size: 13px;
      font-weight: 600;
      line-height: 30px;
      cursor: pointer;
      white-space: nowrap;
      transition: all 0.2s ease;

      &:hover {
        color: #4a5ff3;
        border-color: rgba(74, 95, 243, 0.45);
        background: #edf1fb;
      }

      &.active {
        color: #fff;
        border-color: transparent;
        background: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
      }
    }
  }

  // 设置按钮
  &_btn.el-button.is-circle {
    border: none;
    padding: 0;
    font-size: 14px;
    line-height: 24px;
    height: 24px;
    border-radius: 24px;

    // 鼠标滑过
    &:hover {
      color: #0057ff;
      background-color: transparent;
    }

    .iconfont {
      font-size: 14px;
    }

    // 搜索
    &.search {
      padding: 0 10px;

      &,
      &:hover {
        background-color: #f3f8fc;
      }
    }

    &.about-btn {
      position: relative;

      &:hover::after {
        content: attr(data-title);
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #333;
        color: #fff;
        padding: 5px 10px;
        border-radius: 5px;
        font-size: 12px;
        z-index: 1000;
        white-space: nowrap;
      }
    }
  }

  &_badge {
    .el-badge__content {
      padding: 0;
      width: 16px;
      height: 16px;
      background: #ff2626;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #ffffff;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 14px;

      &.is-fixed {
        top: 2px;
      }
    }
  }

  // 下拉框
  &_dropdown {
    flex-shrink: 0;
    margin-left: 4px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &_dropdown_menu_container::before {
    content: '';
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
    // box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: -8px;
    // left: 65%;
    right: 13px;
    transform: translateX(-65%);
  }

  // 下拉菜单
  &_dropdown_menu {
    color: #333333;
    position: absolute;
    padding-top: 8px;
    top: 31px;
    right: 0;

    &_container {
      position: relative;
      padding: 12px 12px;
      /* 根据需要调整 */
      // left: 80%;
      top: 10px;
      left: 15px;
      z-index: 1000;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
    }

    // 菜单信息项
    &__item {
      padding: 10px 24px;
      height: 40px;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #1e2226;
      line-height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-size: 14px;
      cursor: pointer;
      text-align: center;
      // position: relative;
      // font-weight: 600;

      &:not(:last-child) {
        margin-bottom: 6px;
      }

      &.active,
      &:hover {
        color: #4a5ff3;
        background-color: #edf1fb;
        font-weight: 600;
      }
    }
  }

  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: opacity 0.1s;
  }

  .dropdown-enter,
  .dropdown-leave-to {
    transition: opacity 0.1s;
    opacity: 0;
  }

  // 头像
  &_avatar {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    cursor: pointer;
    object-fit: cover;
    object-position: center;
  }

  &_name {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    display: inline-block;
    max-width: 70px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .header-separator {
    width: 1px;
    height: 24px;
    background-color: #d9d9d9;
    margin: 0 12px;
  }
}
</style>
<style lang="scss">
/* AI 弹窗样式优化：去掉顶部横线与标题留白 */
.ai-dialog {
  .el-dialog {
    border-radius: 8px;
    position: relative;
  }
  .el-dialog__header {
    display: none; /* 隐藏头部，去掉顶部横线与标题区域 */
    border-bottom: none;
    padding: 0;
  }
  .el-dialog__body {
    padding-top: 0; /* 去除因隐藏头部产生的上间距 */
  }
  .ai-close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s ease;
    i {
      font-size: 14px;
    }
    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }
    &:focus {
      outline: none;
    }
  }
}
#language_list {
  position: absolute;
  top: -26px;
  left: -200px;
  width: 200px;
  // max-height: 300px;
  padding-right: 50px;
}

// 租户切换按钮 — 参考工作台按钮样式
.index-head-sider_tenant-switch {
  width: 130px;
  padding: 0 8px;
  // margin-right: 24px;

  .tenant-btn-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    text-align: center;
  }
}

// 租户下拉框
.tenant-dropdown-menu {
  min-width: 200px;

  .tenant-dropdown-body {
    max-height: 236px;
    overflow-y: auto;
    overflow-x: hidden;

    .tenant-item-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 2px;
    }
  }
}
</style>
